import cRadialIndicator from './progressBar/cRadialIndicator.vue'
import cPdfTitle from './Title/cPdfTitle.vue'
import cAddress from './Container/cAddress.vue'
import cSelect from './Input/cSelect.vue'
import subpagefooter from './Container/subpagefooter.vue'
import subpageheader from './Container/subpageheader.vue'

import cTopTitle from './Title/cTopTitle.vue'
import cRoundButton from './Button/cRoundButton.vue'
import cNoBgButton from './Button/cNoBgButton.vue'
import cTextInput from './Input/cTextInput.vue'
import cTextInputNotSpace from './Input/cTextInputNotSpace.vue'
import cSearchInput from './Input/cSearchInput.vue'
import cPwdInput from './Input/cPwdInput.vue'
import cNumInput from './Input/cNumInput.vue'
import cFormatNumInput from './Input/cFormatNumInput.vue'
import cSingleChoice from './Select/cSingleChoice.vue'
import cBackNextButton from './Button/cBackNextButton.vue'
import cInputTitle from './Title/cInputTitle.vue'
import cDropDown from './Select/cDropDown.vue'
import cSinglePopup from './Select/cSinglePopup.vue'
import cSearchPopup from './Select/cSearchPopup.vue'
import cSingleBigChoice from './Select/cSingleBigChoice.vue'
import cBigChoice from './Select/cBigChoice.vue'
import cArgeeChoice from './Select/cArgeeChoice.vue'
import cArgeeButton from './Button/cArgeeButton.vue'
import cNextButton from './Button/cNextButton.vue'
import readPdf from './Pdf/read-pdf'
import cInputAge from './Input/cInputAge.vue'
import cInsiderAdd from './Container/cInsiderAdd'
import cCheckOption from './Select/cCheckOption.vue'
import cAggreePdf from './Pdf/aggree-pdf.vue'
import cCheckBox from './Select/cCheckBox.vue'
import cTopNoTitle from './Title/cTopNoTitle.vue'
import cSingleChoiceCom from './Select/cSingleChoiceCom.vue'
import cDecimalInput from './Input/cDecimalInput';
import Cheader from './Header/header.vue';


export default {
    cRadialIndicator,
    cTopTitle,
    cRoundButton,
    cPdfTitle,
    cAddress,
    cSelect,
    cInsiderAdd,
    subpagefooter,
    subpageheader,
    cNoBgButton,
    cTextInput,
    cTextInputNotSpace,
    cSearchInput,
    cPwdInput,
    cNumInput,
    cSingleChoice,
    cBackNextButton,
    cInputTitle,
    cDropDown,
    cSinglePopup,
    cSearchPopup,
    cSingleBigChoice,
    cBigChoice,
    cArgeeChoice,
    cArgeeButton,
    cNextButton,
    readPdf,
    cInputAge,
    cCheckOption,
    cAggreePdf,
    cCheckBox,
    cTopNoTitle,
    cSingleChoiceCom,
    cFormatNumInput,
    cDecimalInput,
    Cheader
}



// WEBPACK FOOTER //
// ./src/components/index.js